let testHostOverride: string | undefined;

/** Vitest helper: force a tenant host for the current test. */
export function setTestHostOverride(host: string | undefined): void {
  testHostOverride = host;
}

declare global {
  interface Window {
    __WHITELABEL_TEST_HOST__?: string;
  }
}

/** test override → Playwright window flag → VITE_WHITELABEL_HOST (local preview) → location.host */
export function getWhitelabelHost(): string {
  if (testHostOverride) return testHostOverride;
  if (typeof window === 'undefined') return '';
  return (
    window.__WHITELABEL_TEST_HOST__ ??
    (import.meta.env['VITE_WHITELABEL_HOST'] as string | undefined) ??
    window.location.host
  );
}
